import useUniversalStore from "store/universalStore";
import { Loader } from "components";
const CreditProfile = () => {
    const { user } = useUniversalStore();
    return user ?
        <iframe src={`https://app.sahukari.com/?sessionToken=${user?.getSessionToken()}&routeTo=credit-profile`} width="100%" height="87%" />
        : <Loader />
}

export default CreditProfile;